import { t } from '@/lib/i18n';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuthLayout } from '@/components/auth-layout';
import { RegisterForm } from '@/features/auth/registration/form';
import { sessionQueryOptions } from '@/features/auth/session/session-api';
import { useRedirectNavigation } from '@/features/auth/use-redirect-navigation';
import { useDocumentTitle } from '@/hooks/use-document-title';
import { sanitizeRedirect } from '@/lib/routes';

/** The mirror image of the login route; see it for why the guard and the search schema exist. */
export const Route = createFileRoute('/_auth/register')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: sanitizeRedirect(search.redirect),
  }),
  beforeLoad: async ({ context }) => {
    const session =
      await context.queryClient.ensureQueryData(sessionQueryOptions);
    if (session !== null) throw redirect({ to: '/' });
  },
  component: RegisterPage,
});

function RegisterPage() {
  useDocumentTitle(t('注册'));
  const { redirect: redirectTo } = Route.useSearch();
  const goToRedirect = useRedirectNavigation();

  return (
    <AuthLayout
      title={t('创建账号')}
      subtitle={t('填写账号信息，开启你的管理工作空间。')}
    >
      <RegisterForm
        redirectTo={redirectTo}
        onRegistered={() => goToRedirect(redirectTo)}
      />
    </AuthLayout>
  );
}
